export const NoPermission = () => (
    <div className="page-wrap d-flex flex-row align-items-center">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-12 text-center">
                    <span className="display-1 d-block">
                        Access Denied
                    </span>
                    <div className="mb-4 lead">
                        The current user does not have permission to
                        view this page.
                    </div>
                    <a
                        href="/"
                        className="btn btn-link"
                    >
                        Back to Home
                    </a>
                </div>
            </div>
        </div>
    </div>
);

export default NoPermission;
